import { getCurrentApprovalActorIds } from './leaveApproval'

export const INSTANCE_STATUS_TO_LEAVE_TEXT = {
  pending: '待审批',
  approved: '已通过',
  rejected: '已驳回',
  cancelled: '已销假'
}

function pickFirstDefined(...values) {
  return values.find(value => value !== undefined && value !== null && value !== '')
}

function toArray(value) {
  return Array.isArray(value) ? value : []
}

export function extractWorkflowMessage(payload, fallback = '') {
  if (typeof payload?.message === 'string' && payload.message) return payload.message
  if (typeof payload?.error === 'string' && payload.error) return payload.error
  if (typeof payload?.msg === 'string' && payload.msg) return payload.msg
  if (typeof payload?.detail === 'string' && payload.detail) return payload.detail
  return fallback
}

export function extractLeaveApplySuccessItems(payload) {
  const root = payload?.data ?? payload ?? {}
  const successStudents = toArray(root.success_students ?? root.successStudents)
  const leaveIds = toArray(root.leave_ids ?? root.leaveIds)

  if (successStudents.length) {
    return successStudents.map((item, index) => ({
      ...item,
      leaveId: pickFirstDefined(item?.leave_id, item?.leaveId, leaveIds[index], leaveIds[0]),
      instanceId: pickFirstDefined(item?.instance_id, item?.instanceId),
      currentApproverId: pickFirstDefined(item?.current_approver_id, item?.currentApproverId),
      approvalSteps: pickFirstDefined(item?.approval_steps, item?.approvalSteps)
    }))
  }

  const leaveId = pickFirstDefined(root.leave_id, root.leaveId, root.id, leaveIds[0])
  const instanceId = pickFirstDefined(root.instance_id, root.instanceId)
  if (leaveId == null && instanceId == null) return []

  return [{
    ...root,
    leaveId,
    instanceId,
    currentApproverId: pickFirstDefined(root.current_approver_id, root.currentApproverId),
    approvalSteps: pickFirstDefined(root.approval_steps, root.approvalSteps)
  }]
}

export function extractLeaveApplySuccessLeaveIds(payload) {
  const seen = new Set()
  return extractLeaveApplySuccessItems(payload)
    .map(item => pickFirstDefined(item?.leaveId, item?.leave_id))
    .filter((id) => {
      if (id === undefined || id === null || id === '') return false
      const key = String(id)
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })
}

export function normalizeApprovalInstancePayload(payload) {
  const root = payload?.data ?? payload ?? {}
  return {
    instance: root.instance ?? root ?? {},
    approvalRecords: toArray(root.approval_records)
  }
}

export function didCurrentActorCompleteApproval(payload, state = {}) {
  const actorIds = getCurrentApprovalActorIds(state)
  const { instance, approvalRecords } = normalizeApprovalInstancePayload(payload)
  const lastActorRecord = [...approvalRecords]
    .reverse()
    .find(record => actorIds.has(String(record?.approver_id ?? record?.approverId ?? '')))

  if (!lastActorRecord) return false
  if (instance?.status && instance.status !== 'pending') return true

  const currentApproverId = pickFirstDefined(instance?.current_approver_id, instance?.currentApproverId)
  if (currentApproverId == null) return true
  return !actorIds.has(String(currentApproverId))
}

export function buildLeaveApprovalPatch(payload, fallbackComment = '') {
  const { instance, approvalRecords } = normalizeApprovalInstancePayload(payload)
  const lastRecord = approvalRecords.length ? approvalRecords[approvalRecords.length - 1] : null
  const patch = {}

  if (instance?.status && INSTANCE_STATUS_TO_LEAVE_TEXT[instance.status]) {
    patch.status = INSTANCE_STATUS_TO_LEAVE_TEXT[instance.status]
    patch.approvalStatus = instance.status
  }

  if (instance && ('current_approver_id' in instance || 'currentApproverId' in instance)) {
    patch.currentApproverId = pickFirstDefined(instance.current_approver_id, instance.currentApproverId) ?? null
  }

  if (lastRecord?.comment || fallbackComment) {
    patch.approvalComment = lastRecord?.comment || fallbackComment
  }

  return patch
}
